"use client";

import Image, { type ImageProps } from "next/image";

import { useImageFade } from "./use-image-fade";

/**
 * A `fill` next/image that eases in (opacity 0→1, 700ms) once it loads, instead
 * of popping. The fade lives on a wrapping layer so the image keeps its own
 * className/transitions (e.g. a hover scale or grayscale→colour) with no
 * transition-property conflict. The parent must be positioned + sized (same as
 * `fill` already requires); pass `fill`. For non-fill / plain images use
 * {@link FadeImage}; to fade a whole group on one image's load, gate a wrapper on
 * {@link useImageFade} directly (see ProductGallery / RentalItemCard).
 */
export function FadeInImage({ alt, className = "", ...props }: ImageProps) {
  const { loaded, ref, onLoad } = useImageFade();
  return (
    <span
      className={`absolute inset-0 block transition-opacity duration-700 ease-out ${
        loaded ? "opacity-100" : "opacity-0"
      }`}
    >
      <Image
        {...props}
        alt={alt}
        ref={ref}
        onLoad={onLoad}
        className={className}
      />
    </span>
  );
}
